import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=11109284&"
import script from "./BoxCard.vue?vue&type=script&lang=ts&"
export * from "./BoxCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JobDescription: require('/srv/frontend-v3/components/JobDetail/JobDescription.vue').default,JobSubInformation: require('/srv/frontend-v3/components/JobDetail/JobSubInformation.vue').default})
